import { Box, CircularProgress, Stack } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";
import { settingsScrollPageSx, settingsScrollPageStackSx } from "../../../styles/globalStyles";
import { formatGoogleGroupQualification } from "./googleGroupsConstants";
import { useGoogleGroupsPageState } from "./hooks/useGoogleGroupsPageState";
import GoogleGroupCard from "./display/GoogleGroupCard";
import GoogleGroupsToolbar from "./display/GoogleGroupsToolbar";
import GoogleGroupsConfigSection from "./display/GoogleGroupsConfigSection";

export default function GoogleGroupsPage() {
  const {
    canEdit,
    loading,
    saving,
    newsletterMapping,
    availableLabels,
    handleAddQualification,
    handleRemoveQualification,
    handleAddGroup,
    handleRemoveGroup,
    getAvailableQualifications,
    onSave,
    config,
    canViewGoogleConfig,
    canEditGoogleConfig,
  } = useGoogleGroupsPageState();

  const groupLabels = Object.keys(newsletterMapping);

  return (
    <Box sx={settingsScrollPageSx}>
      <Stack spacing={2} sx={settingsScrollPageStackSx}>
        {canViewGoogleConfig && config ? (
          <GoogleGroupsConfigSection config={config} canEditBackend={canEditGoogleConfig} />
        ) : null}

        <GoogleGroupsToolbar
          canEdit={canEdit}
          loading={loading}
          saving={saving}
          availableLabels={availableLabels}
          onAddGroup={handleAddGroup}
          onSave={() => void onSave()}
        />

        {!loading && groupLabels.length === 0 ? (
          <DarkTypography colorVariant="muted">Aucun groupe</DarkTypography>
        ) : null}

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : null}

        {!loading
          ? groupLabels.map((label) => (
              <GoogleGroupCard
                key={label}
                label={label}
                qualifications={newsletterMapping[label] || []}
                canEdit={canEdit}
                availableQualifications={getAvailableQualifications(label)}
                onRemoveQualification={handleRemoveQualification}
                onAddQualification={handleAddQualification}
                onRemoveGroup={handleRemoveGroup}
                getQualificationLabel={formatGoogleGroupQualification}
              />
            ))
          : null}
      </Stack>
    </Box>
  );
}
